import { useEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

// project imports
import AnimateButton from "ui-component/extended/AnimateButton";

// assets
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useUserInfo from "hooks/useUserInfo";

// ============================|| FIREBASE - LOGIN ||============================ //

const Login = ({ ...others }) => {
  const theme = useTheme();
  const userInfo = useUserInfo();

  const [values, setValues] = useState({
    username: null,
    password: null,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (userInfo) {
      window.location = '/'
      // TODO: Redirect out of login page
    }
  }, [userInfo]);

  return (
    <>
      <form
        noValidate
        onSubmit={async (e) => {
          e.preventDefault();
          e.stopPropagation();

          setIsSubmitting(true);
          setError(null);

          try {
            const response = await fetch("/backend/authentication/login/", {
              method: "POST",
              headers: {
                "content-type": "application/json",
              },
              body: JSON.stringify({
                username: values.username,
                password: values.password,
              }),
            });

            if (response.ok) {
              // Login bem-sucedido
              window.location = "/";
            } else {
              // Login falhou
              const data = await response.json().catch(() => ({}));
              setError(data.error || "Usuário ou senha inválidos");
              setIsSubmitting(false);
            }
          } catch (err) {
            setError("Erro ao conectar com o servidor. Tente novamente.");
            setIsSubmitting(false);
          }
        }}
        {...others}
      >
        <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
          <InputLabel htmlFor="outlined-adornment-username-login">
            Usuário
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-username-login"
            type="username"
            value={values.username}
            name="username"
            onChange={(e) =>
              setValues((prev) => ({ ...prev, username: e.target.value }))
            }
            label="Usuário"
            inputProps={{}}
          />
        </FormControl>

        <FormControl
          fullWidth
          //   error={Boolean(touched.password && errors.password)}
          sx={{ ...theme.typography.customInput }}
        >
          <InputLabel htmlFor="outlined-adornment-password-login">
            Senha
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password-login"
            type={showPassword ? "text" : "password"}
            value={values.password}
            name="password"
            onChange={(e) =>
              setValues((prev) => ({ ...prev, password: e.target.value }))
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  size="large"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
            inputProps={{}}
          />
        </FormControl>
        
        {error && (
          <Box sx={{ mt: 3 }}>
            <FormHelperText error>{error}</FormHelperText>
          </Box>
        )}

        <Box sx={{ mt: 2 }}>
          <AnimateButton>
            <Button
              disableElevation
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              color="secondary"
            >
              {isSubmitting ? "Entrando..." : "Sign in"}
            </Button>
          </AnimateButton>
        </Box>
      </form>
    </>
  );
};

export default Login;
